import { observer } from "mobx-react-lite";
import { Divider, Grid, GridColumn, Header } from "semantic-ui-react";
import DeletedCustomer from "./DeletedCustomer";
import DeletedTicket from "./DeletedTicket";
import DeletedTicketSession from "./DeletedTicketSession";
import { Link, useParams } from "react-router-dom";
import PageHeader from "../../../app/layout/PageHeader";
import DeletedVehicle from "./DeletedVehicle";

export default observer(function ClientDataRecovery() {
  const { id } = useParams<{ id: string }>();
  return (
    <Grid>
      <Grid.Row>
        <GridColumn textAlign="right">
          <Link to={`/admin/company/${id}`}>Back to View Company</Link>
        </GridColumn>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <PageHeader
            type="h1"
            header="Deleted Customers"
            className="modal-text-color"
            textAlign="left"
            divider
            addTitle
          />
          <DeletedCustomer clientId={id ?? ""} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Header
            as="h1"
            content="Deleted Tickets"
            className="modal-text-color"
            textAlign="left"
          />
          <Divider />
          <DeletedTicket clientId={id ?? ""} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Header
            as="h1"
            content="Deleted Abandoned Tickets"
            className="modal-text-color"
            textAlign="left"
          />
          <Divider />
          <DeletedTicketSession clientId={id ?? ""} />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={1}>
        <Grid.Column>
          <Header
            as="h1"
            content="Deleted Vehicles"
            className="modal-text-color"
            textAlign="left"
          />
          <Divider />
          <DeletedVehicle clientId={id ?? ""} />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
});
